import React from 'react';
import './changePass.style.sass';
import {Alert, Button, ControlLabel, Form, FormControl, FormGroup, Modal} from "rsuite";
import modalsTypes from "../../redux/modals/modals.types";
import {createStructuredSelector} from "reselect";
import {selectChangePassModal} from "../../redux/modals/modals.selector";
import {connect} from "react-redux";
import UserTypes from "../../redux/user/user.types";
import Axios from "axios";
import {selectIsDemo, selectToken, selectUserInfo} from "../../redux/user/user.selector";
import {RemoveSelectedCar, RemoveCarsData, SetSelectedSingleCar} from '../../redux/cars/cars.action'
import {selectIconsLayer, selectIsMain, selectMap} from "../../redux/map/map.selector";
import {selectCarsData} from "../../redux/cars/cars.selector";
import mapTypes from "../../redux/map/map.types";
import {SetToken} from "../../redux/user/user.actions";


const ChangePassComponent = ({ToggleChangePass,IconsLayer, CarsData, mapData, ChangePassModal,RemoveCarsData,
                                 UserRemove, getUserData, RemoveSelectedCar, IsDemo, ToggleIsMain, getIsMain, getToken
    ,RemoveToken, RemoveSingleCarData
}) => {

    const handleSubmit = () => {
        const pass1 = document.getElementById('Changepass1').value;
        const pass2 = document.getElementById('Changepass2').value;
        const repass = document.getElementById('repass2').value;
        const userPhone = getUserData.phone;
        const data = {
            phone: userPhone,
            pass: pass1,
            pass2: pass2
        };
        IsDemo ?
            Alert.error('در تست پنل قادر به تغییر رمز نمیباشید !', 3000)
            :
            pass1 === getUserData.pass
                ? pass2 === repass
                    ? Axios.post(`${getToken}/changePass`, JSON.stringify(data))
                        .then(res =>{if(res.data !== 'success'){Alert.error('مشکلی در برقراری ارتباط وجود دارد، لطفا دوباره تکرار کنید',4000)}} )
                        .then(()=>ToggleChangePass())
                    : Alert.error('تکرار رمز عبور جدید با رمز عبور جدید برابر نیست !', 4000)
                : Alert.error('رمز عبور وارد شده با رمز عبور فعلی شما همخوانی ندارد',4000)

    };

    let map = mapData;

    return (
        <div className="modal-container">
            <Modal size='xs' show={ChangePassModal} onHide={() => ToggleChangePass()}>
                <Modal.Header>
                    <Modal.Title>تغییر رمز عبور</Modal.Title>
                </Modal.Header>
                <Form onSubmit={() => handleSubmit()}>
                    <Modal.Body>
                        <FormGroup>
                            <ControlLabel>رمز عبور کنونی</ControlLabel>
                            <FormControl id='Changepass1' name="pass"/>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>رمز عبور جدید</ControlLabel>
                            <FormControl id='Changepass2' type='password' name="pass2"/>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>تکرار رمز عبور جدید</ControlLabel>
                            <FormControl id='repass2' type='password' name="checkPass"/>
                        </FormGroup>

                    </Modal.Body>
                    <Modal.Footer style={{textAlign: 'center'}}>
                        <Button type="submit" style={{marginLeft: "10px"}} className='Btn1'>
                            تغییر رمز
                        </Button>
                        <Button onClick={() => {
                            IconsLayer.map(x=> map.removeLayer(x));
                            UserRemove();
                            RemoveCarsData();
                            RemoveSelectedCar();
                            ToggleChangePass();
                            RemoveToken();
                            RemoveSingleCarData();
                            if(getIsMain){
                                ToggleIsMain();
                            }
                        }}
                                className='BtnExit'

                        >
                            خروج کاربر
                        </Button>
                        <Button onClick={() => ToggleChangePass()} className='BtnClose'>
                            بستن
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </div>
    );
};

const mapDispatchToProps = dispatch => ({
    ToggleChangePass: () => dispatch({type: modalsTypes.TOGGLE_CHANGE_PASS}),
    UserRemove : () => dispatch({type: UserTypes.REMOVE_USER}),
    RemoveSelectedCar : () => dispatch(RemoveSelectedCar()),
    RemoveCarsData : () => dispatch(RemoveCarsData()),
    ToggleIsMain: () => dispatch({type: mapTypes.TOGGLE_IS_MAIN}),
    RemoveToken: ()=> dispatch(SetToken('')),
    RemoveSingleCarData: ()=> dispatch(SetSelectedSingleCar(''))
});

const mapStateToProps = createStructuredSelector({
    ChangePassModal: selectChangePassModal,
    getUserData: selectUserInfo,
    mapData : selectMap,
    CarsData: selectCarsData,
    IconsLayer: selectIconsLayer,
    IsDemo : selectIsDemo,
    getIsMain: selectIsMain,
    getToken: selectToken
});


export default connect(mapStateToProps, mapDispatchToProps)(ChangePassComponent);